module.exports = __webpack_public_path__ + "static/media/t1.0d2cde35.png";